import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { trackEventUniversal } from 'helpers/index';

import { ButtonUnstyled } from '.';
import { ButtonUnstyledProps } from './ButtonUnstyled';

const Button: React.FC<{ trackName?: string; to?: string; variant?: 'white' | 'blue' } & ButtonUnstyledProps> = ({
  className,
  children,
  trackName,
  onClick,
  variant = 'blue',
  ...props
}) => {
  return (
    <ButtonUnstyled
      className={twMerge(
        clsx(
          'py-16 px-24 text-center rounded-128 font-basis-grotesque-pro font-bold inline-flex items-center justify-center w-auto text-md',
          'text-white bg-blue-bright hover:text-white focus:text-white active:text-white',
          variant === 'white' &&
            'text-blue-bright bg-white hover:text-blue-bright focus:text-blue-bright active:text-blue-bright',
          className,
        ),
      )}
      onClick={(event) => {
        if (trackName) {
          trackEventUniversal('Clicked', {
            event_label: trackName,
          });
        }

        if (onClick) {
          onClick(event);
        }
      }}
      {...props}
    >
      <span className="relative top-2 pointer-events-none">{children}</span>
    </ButtonUnstyled>
  );
};

export default Button;
